export const ERROR_FILTER_ENABLED = 'ERROR_FILTER_ENABLED'
export const ERROR_FILTER_DISABLED = 'ERROR_FILTER_DISABLED'

function enable(errorFilter) {
  return {
    type: ERROR_FILTER_ENABLED,
    errorFilter,
  }
}

function disable() {
  return {
    type: ERROR_FILTER_DISABLED,
    ERRORFilter: null,
  }
}

export function enableErrorFilter(filter) {
  return (dispatch) => {
    dispatch(enable(filter))
  }
}

export function disableErrorFilter() {
  return (dispatch) => {
    dispatch(disable())
  }
}
